/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Bed = {
    properties: {
        id: {
    type: 'number',
},
        name: {
    type: 'string',
    isRequired: true,
},
        roomId: {
    type: 'number',
},
    },
};